import script from "./SmsHistModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsHistModal.vue?vue&type=script&setup=true&lang=js"

import "./SmsHistModal.vue?vue&type=style&index=0&id=116160e4&lang=scss"

const __exports__ = script;

export default __exports__